import accountInformationStore, { AccountInformationStore } from '@/stores/accountInformationStore';
import airportDataStore, { AirportDataStore } from '@/stores/airportDataStore';
import amusementParkTicketDataStore, {
  AmusementParkTicketDataStore,
} from '@/stores/amusementParkTicketDataStore';
import appSettingsStore, { AppSettingsStore } from '@/stores/appSettingsStore';
import commonStore, { CommonStore } from '@/stores/commonStore';
import countryStore, { CountryStore } from '@/stores/countryStore';
import flightDataStore, { FlightDataStore } from '@/stores/flightDataStore';
import hotelStore, { HotelStore } from '@/stores/hotelStore';
import insuranceDataStore, { InsuranceDataStore } from '@/stores/insuranceDataStore';
import partnerStore, { PartnerStore } from '@/stores/partnerStore';
import placeDataStore, { PlaceDataStore } from '@/stores/placeDataStore';
import selectedBusinessPartnerAndServiceStore, {
  SelectedBusinessPartnerAndServiceStore,
} from '@/stores/selectedBusinessPartnerAndServiceStore';
import selectedWebPartnerAndServiceStore, {
  SelectedWebPartnerAndServiceStore,
} from '@/stores/selectedWebPartnerAndServiceStore';
import serviceDataStore, { ServiceDataStore } from '@/stores/serviceDataStore';
import siteDataStore, { SiteDataStore } from '@/stores/siteDataStore';
import tourStore, { TourStore } from '@/stores/tourStore';

export type RootStore = {
  commonStore: CommonStore;
  airportDataStore: AirportDataStore;
  accountInformationStore: AccountInformationStore;
  serviceDataStore: ServiceDataStore;
  flightDataStore: FlightDataStore;
  partnerStore: PartnerStore;
  selectedWebPartnerAndServiceStore: SelectedWebPartnerAndServiceStore;
  selectedBusinessPartnerAndServiceStore: SelectedBusinessPartnerAndServiceStore;

  hotelStore: HotelStore;
  siteDataStore: SiteDataStore;
  amusementParkTicketDataStore: AmusementParkTicketDataStore;
  insuranceDataStore: InsuranceDataStore;
  placeDataStore: PlaceDataStore;
  appSettingsStore: AppSettingsStore;
  tourStore: TourStore;
  countryStore: CountryStore;
};

const rootStore: RootStore = {
  commonStore,
  airportDataStore,
  accountInformationStore,
  serviceDataStore,
  flightDataStore,
  partnerStore,
  selectedWebPartnerAndServiceStore,
  selectedBusinessPartnerAndServiceStore,
  hotelStore,
  siteDataStore,
  amusementParkTicketDataStore,
  insuranceDataStore,
  placeDataStore,
  appSettingsStore,
  tourStore,
  countryStore,
};

export default rootStore;
